//列表
export const read={label:'阅读状态'};
export const unread={label:'未读'};
export const messageTitle={label:'消息标题'};
export const receiver={label:'接收人'};
export const sendUser={label:'发送人'};
export const messageTime={label:'消息发送时间'};
export const important={label:'重要'};
export const startTime={label:'开始日期'};
export const endTime={label:'结束日期'};
export const messageContent={label:'消息内容'};
export const userAccount={label:'用户账户'};
export const userName={label:'用户名称'};
export const activate={label:'激活'};
export const receivedMessage={label:'已接收的消息'};
export const workflowSLAMessage={label:'工作流SLA消息'};
export const businessMessage={label:'商业消息'};
export const personalMessage={label:'个人信息'};
export const systemNotification={label:'系统通知'};
export const sentMessage={label:'已发送邮件'};

//按钮名称
export const messagesButton={label:'消息：'};
export const allButton={label:'全部'};
export const unreadButton={label:'未读'};
export const readButton={label:'已读'};
export const importantButton={label:'重要'};
export const cancelImportantButton={label:'取消重要'};
export const CapitalAllButton={label:'全部'};
export const markReadButton={label:'标记为已读'};
export const markedAsButton={label:'标记为'};
export const SendMessageButton={label:'发送消息'};
export const exitButton={label:'退出'};
export const searchButton={label:'查询'};
export const clearButton={label:'清空'};
export const lowerExitButton={label:'退出'};
export const sendButton={label:'发送'};
export const okButton={label:'确定'};
export const itemsPerPage={label:'条/页'};
export const jumpTo={label:'跳至'};
export const page={label:'页'};


//标题、提示语
export const selectUser={label:'请单击加号选择用户'};
export const messageConversation={label:'消息内容'};
export const messageInquiry={label:'消息查询'};
export const SendAMessageButton={label:'发送消息'};
export const pleaseSelectUser={label:'请选择用户'};
export const searchCondition={label:'搜索条件'};
export const queryUser={label:'查询用户:'};
export const message={label:'消息'};

